module.exports = __webpack_public_path__ + "static/media/rectangle-hiw.cf19ba91.png";